// About page story timeline (includes/functions/render-about-page.php): fills
// the vertical rail as the reader scrolls, marks passed chapters, and fades
// each chapter in when it reaches the viewport. Content stays fully visible
// without JS or with reduced motion — the hide-then-reveal styles only apply
// once .about-timeline--js is added here.

function init() {
    const timeline = document.querySelector('[data-about-timeline]');
    const rail = timeline && timeline.querySelector('[data-timeline-rail]');
    if (!rail) return;

    const items = rail.querySelectorAll('[data-timeline-item]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!reduceMotion && 'IntersectionObserver' in window) {
        timeline.classList.add('about-timeline--js');
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    observer.unobserve(entry.target);
                }
            });
        }, { rootMargin: '0px 0px -12% 0px' });
        items.forEach((item) => observer.observe(item));
    }

    let ticking = false;

    function update() {
        ticking = false;
        // The "reading line" sits a bit above the middle of the screen; the
        // rail is filled down to wherever that line crosses it.
        const anchor = window.innerHeight * 0.55;
        const rect = rail.getBoundingClientRect();
        const progress = Math.min(1, Math.max(0, (anchor - rect.top) / rect.height));
        rail.style.setProperty('--timeline-progress', progress.toFixed(4));
        items.forEach((item) => {
            item.classList.toggle('is-passed', item.getBoundingClientRect().top < anchor);
        });
    }

    function requestUpdate() {
        if (!ticking) {
            ticking = true;
            window.requestAnimationFrame(update);
        }
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    update();
}

export default { init };
